export const beforeItems = [
  'Reviewing craniofacial growth concepts across multiple disconnected resources.',
  'Feeling uncertain about how to organize growth-related clinical findings.',
  'Struggling to connect facial observations with skeletal relationships.',
  'Finding it difficult to distinguish developmental variations from findings that require further evaluation.',
  'Studying orthopedic appliances without a clear understanding of their underlying principles.',
  'Lacking a consistent framework for documenting growth-related observations.',
];

export const afterItems = [
  'Follow an organized framework for evaluating craniofacial development.',
  'Understand the main indicators used in skeletal maturity assessment.',
  'Connect facial, dental, and skeletal findings more systematically.',
  'Recognize clinical patterns that warrant additional investigation or specialist referral.',
  'Understand the foundations and limitations of orthopedic treatment approaches.',
  'Use structured worksheets and visual references to support clinical learning.',
];
